export default "__VITE_ASSET__tUzSqQAd__"